import { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { BaseOptions, ErrorResponse, GetOptions, PostOptions } from '../../modules/workflow/workflow.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/core/services/http.service';
import { workFlowHttpService } from 'src/app/core/services/workFlowHttp.service';
import { APIResponse } from 'src/app/core/common/interfaces';
import { NotifyService } from './notify.service';
import { Report } from 'notiflix/build/notiflix-report-aio';
import { Notify } from 'notiflix';



// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// TODO: fix this file and all file use this file
@Injectable({
  providedIn: 'root',
})

export class WorkflowHttpService {
  private errorHandler: ErrorHandler;
  // protected userInfo: UserProfileInfoStruct;
  accessToken: string;
  refreshToken: string;
  accessTokenStartedAt: number;
  protected accessTokenName = 'access_token';
  protected accessTokenTimeName = '_access_token_started_at';
  protected refreshTokenName = '_refresh_token';
  userInfoUpdated = new BehaviorSubject<boolean>(false);
  userAuthUpdated$ = new BehaviorSubject<boolean>(undefined);
  protected isLoginWinodwOpened = false;

  // I initialize the ApiClient.
  constructor(
    errorHandler: ErrorHandler,
    private route: Router,
    // public dialog: MatDialog,
    // private transmit: TransmitService
    private _httpClient: HttpClient,
    private _httpService: workFlowHttpService
  ) {
    this.errorHandler = errorHandler;
    this.loadAuthTokens();
    this._setDefaultHeaders()
  }


  private _setDefaultHeaders() {
    // TODO:fix
    var headers = new Headers();
    headers.append('authorization', this.accessToken);
  }

  // ---
  // PUBLIC METHODS.
  // ---

  // I perform a GET request with the given options
  public async get_V2<T>(url: string, options?: GetOptions, def?: T): Promise<APIResponse> {
    options = this.readyRequestHeader(options);

    // =>send request
    return await this._httpService.getSuccessResult<T>(
      {
        path: url,
        method: 'GET',
        params: options.params,
        headers: options.headers
      }, def)
    // .catch(
    //   tap(
    //     {
    //       next: (data) => {
    //         return data;
    //       },
    // this.manageRequestErrors(error, options);
    //       error: (error) => console.error(error)
    //     }
    //   )
    // );
  }
  // public get<T>(url: string, options?: GetOptions): Observable<T> {
  //   options = this.readyRequestHeader(options);
  //   // =>send request
  //   return this._httpClient.get<T>(environment.workflowBaseUrl + url,
  //     {
  //       params: options.params,
  //       headers: options.headers
  //     }).pipe(
  //       tap(
  //         {
  //           next: (data) => {
  //             return data;
  //           },
  //           // this.manageRequestErrors(error, options);
  //           error: (error) => console.error(error)
  //         }
  //       )
  //     );
  // }

  // public getWorkerInfo(id: string): Observable<any> {
  //   return this.get<any>('worker/info', { params: { id } });
  // }

  public async getWorkerInfo_V2(id: string): Promise<any> {
    return this.get_V2<any>('worker/info', { params: { id } });
  }

  // public async checkWorker(id: string): Promise<boolean> {
  //   return new Promise<any>((res) => {
  //     const intervalId = setInterval(() => {
  //       this.getWorkerInfo(id).subscribe(response => {
  //         if (response.data.ended_at) {
  //           if (response.data.success) {
  //             clearInterval(intervalId);
  //             return res(true);
  //           }
  //           if (response.data.success === false) {
  //             clearInterval(intervalId);
  //             return res(false);
  //           }
  //         }
  //       }, (error) => {
  //         clearInterval(intervalId);
  //         return res(false)
  //       })
  //     }, 300)
  //   })
  // }

  public async checkWorker_V2(id: string): Promise<boolean> {
    if (!id) return false;
    return new Promise<any>((res) => {
      let isLoading = false;
      const intervalId = setInterval(async () => {
        if (isLoading) return;
        isLoading = true;
        let result = await this.getWorkerInfo_V2(id);
        if (result.data?.ended_at) {
          if (result.data.success === true) {
            clearInterval(intervalId);
            return res(true);
          }
          else {
            Notify.failure('مشکلی بوجود آمده است!!', () => {
              Report.failure('خطا در سیستم',
                result.data.response.error,
                'متوجه شدم'
              )
            });
            // Report.failure('خطا در سیستم', 'not found such worker with this id', 'متوجه شدم');
          }
          clearInterval(intervalId);
          return res(false);
        }
        isLoading = false;
      }, 300);
    })
  }

  public post_V2<T>(url: string, body: any, options: PostOptions = {}, def?: T): Promise<APIResponse> {
    options = this.readyRequestHeader(options);
    return this._httpService.getSuccessResult<T>(
      {
        path: url,
        method: 'POST',
        headers: options.headers,
        body: body,
      },
      def
    )
  }

  // public post<T>(url: string, body: any, options: PostOptions = {}): Observable<T> {
  //   options = this.readyRequestHeader(options);
  //   return this._httpClient
  //     .post<T>(environment.workflowBaseUrl + url, body, {
  //       headers: options.headers,
  //     })
  //     .pipe(
  //       tap({
  //         next: (data) => {
  //           return data;
  //         },
  //         // this.manageRequestErrors(error, options);
  //         error: (error) => console.error(error),
  //       })
  //     );
  // }

  // TODO: fix
  // public put<T>(options: PostOptions): T {
  //   try {
  //     options = this.readyRequestHeader(options);
  //     // this.transmit.emit('page-loading', true);
  //     var axiosResponse = await axios({
  //       method: 'put',
  //       url: environment.workflowBaseUrl+ url,
  //       data: options.data,
  //       headers: options.headers,
  //     });
  //     return axiosResponse.data;
  //   } catch (error) {
  //     this.manageRequestErrors(error, options);
  //     throw new Error(String(error));
  //
  //     return Promise.reject(this.normalizeError(error));
  //   } finally {
  //     // this.transmit.emit('page-loading', false);
  //   }
  // }


  // TODO: fxi
  // public delete<T>(options: DeleteOptions): T {
  //   try {
  //     options = this.readyRequestHeader(options);
  //     var axiosResponse = await axios({
  //       method: 'delete',
  //       url: environment.workflowBaseUrl+url,
  //       headers: options.headers,
  //     });
  //
  //     return axiosResponse.data;
  //   } catch (error) {
  //     this.manageRequestErrors(error, options);
  //     throw new Error(String(error));
  //
  //     return Promise.reject(this.normalizeError(error));
  //   }
  // }

  // TODO: fix
  manageRequestErrors(error, options: BaseOptions) {
    // =>show error toast, if exist
    if (
      !options.noErrorToast &&
      error?.response?.data &&
      typeof error.response.data === 'object' &&
      Object.keys(error.response.data).length > 0
    ) {
      let messages = error.response.data[Object.keys(error.response.data)[0]];
      let message = messages;
      if (Array.isArray(messages) && messages.length > 0) {
        message = messages[0];
      }
      // this.transmit.emit('snackbar-message', { text: message, mode: 'error' });

    }
    // =>if 401
    if (error?.response?.status == 401) {
      if (!options.noRedirectToLoginIf401) {
        //FIXME:refresh token not implement
        // =>redirect to login
        this.goToLogin();
        return;
      }
    }
    // this.transmit.emit('page-loading', false);
  }

  setAuthTokens(access: string, refresh: string) {
    // =>set access token
    this.accessToken = access;
    localStorage.setItem(this.accessTokenName, access);
    // =>set refresh token
    this.refreshToken = refresh;
    localStorage.setItem(this.refreshTokenName, access);
    // =>set access token time
    this.accessTokenStartedAt = new Date().getTime();
    localStorage.setItem(
      this.accessTokenTimeName,
      String(this.accessTokenStartedAt)
    );
  }

  resetAuthTokens() {
    localStorage.removeItem(this.accessTokenName);
    this.accessToken = undefined;
    // this.userInfo = undefined;
    localStorage.removeItem(this.refreshTokenName);
    this.refreshToken = undefined;
    localStorage.removeItem(this.accessTokenTimeName);
    this.accessTokenStartedAt = undefined;
  }

  loadAuthTokens() {
    if (localStorage.getItem(this.accessTokenName)) {
      this.accessToken = localStorage.getItem(this.accessTokenName);
    }
    if (localStorage.getItem(this.refreshTokenName)) {
      this.refreshToken = localStorage.getItem(this.refreshTokenName);
    }
    if (localStorage.getItem(this.accessTokenTimeName)) {
      this.accessTokenStartedAt = Number(
        localStorage.getItem(this.accessTokenTimeName)
      );
    }

    // =>load user info
    // if (this.accessToken && !this.userInfo) {
    //   this.fetchUserInfo();
    // }
  }
  readyRequestHeader(options: BaseOptions = {}) {
    if (!options.headers) {
      options.headers = {
        authorization: this.accessToken
      }
    }
    // =>set access token
    if (
      this.accessToken &&
      options.headers['authorization'] === undefined &&
      this.accessTokenIsValid()
    ) {
      options.headers['authorization'] = 'Bearer ' + this.accessToken;
    }

    return options;
  }

  isLogin() {
    // if (!this.accessToken || !this.userInfo) return false;
    if (!this.accessTokenIsValid()) return false;

    return true;
  }

  logout() {
    this.resetAuthTokens();
    // =>redirect to home page
    this.route.navigate(['home']);
  }

  accessTokenIsValid() {
    if (!this.accessTokenStartedAt) return false;
    let now = new Date().getTime();
    let diff = now - this.accessTokenStartedAt;
    // return diff < SettingsService.ACCESS_TOKEN_LIFE_TIME;
    return diff < 5;
  }

  goToLogin() {
    if (this.isLoginWinodwOpened) return;
    // this.route.navigate(['/login']);
    this.isLoginWinodwOpened = true;
    // this.dialog
    //   .open(LoginComponent, { width: '500px', height: '450px' })
    //   .afterClosed()
    //   .subscribe((it) => {
    //     this.isLoginWinodwOpened = false;
    //   });
  }

  // async fetchUserInfo() {
  //   try {
  //     // =>get user info
  //     let res = await this.get({
  //       url: url('userInfo'),
  //     });
  //     this.userInfo = res as any;
  //     this.userInfoUpdated.next(true);
  //   } catch (e) {}
  //   this.userAuthUpdated$.next(this.isLogin());
  // }

  // hasActivityType(id) {
  //   return this.userInfo.activity_type.map((item: any) => item.id).includes(id);
  // }

  // async notifications(): Promise<Notifications> {
  //   // =>get profile notifications
  //   let res = await this.get({
  //     // url: url('notifications'),
  //   });
  //   // return res as Promise<Notifications>;
  // }

  // getProfileInfo(): UserProfileInfoStruct {
  //   if (this.userInfo && this.userInfo.logo) {
  //     this.userInfo.absLogo =
  //       SettingsService.BASE_MEDIA_URL + this.userInfo.logo;
  //   } else if (this.userInfo && this.userInfo.image) {
  //     this.userInfo.absLogo =
  //       SettingsService.BASE_MEDIA_URL + this.userInfo.image;
  //   } else if (this.userInfo && this.userInfo.picture) {
  //     this.userInfo.absLogo =
  //       SettingsService.BASE_MEDIA_URL + this.userInfo.picture;
  //   }
  //   return (
  //     this.userInfo ?? {
  //       id: 0,
  //       activity_type: [],
  //       picture: '',
  //       name: '',
  //       logo: '../../assets/css/images/users/avatar-1.jpg',
  //       absLogo: '../../assets/css/images/users/avatar-1.jpg',
  //       user: {
  //         first_name: '',
  //         id: 0,
  //         is_verify: false,
  //         last_name: '',
  //         manager_national_id: 0,
  //         person_type: 'N',
  //         phone: null,
  //         second_signup_verify: false,
  //         phone_verified: false,
  //         username: 'guest',
  //       },
  //     }
  //   );
  // }

  // getUserInfo(): UserInfoStruct {
  //   return (
  //     this.userInfo?.user ?? {
  //       first_name: '',
  //       id: 0,
  //       is_verify: false,
  //       last_name: '',
  //       manager_national_id: 0,
  //       person_type: 'N',
  //       phone: null,
  //       phone_verified: false,
  //       second_signup_verify: false,
  //       username: 'guest',
  //     }
  //   );
  // }

  // getUserName() {
  //   // FIXME: delavar name admin has problem
  //   let name = 'بی نام';
  //   let userInfo = this.getUserInfo();
  //   if (userInfo.first_name || userInfo.last_name) {
  //     if (userInfo.first_name) {
  //       name = userInfo.first_name;
  //     }
  //     if (userInfo.last_name) {
  //       name += ' ' + userInfo.last_name;
  //     }
  //   } else if (userInfo.phone) {
  //     name = userInfo.phone;
  //   } else if (userInfo.username) {
  //     name = userInfo.username;
  //   }

  //   return name;
  // }

  // ---
  // PRIVATE METHODS.
  // ---

  // Errors can occur for a variety of reasons. I normalize the error response so that
  // the calling context can assume a standard error structure.
  private normalizeError(error: any): ErrorResponse {
    this.errorHandler.handleError(error);

    // NOTE: Since I'm not really dealing with a production API, this doesn't really
    // normalize anything (ie, this is not the focus of this demo).
    return {
      id: '-1',
      code: 'UnknownError',
      message: 'An unexpected error occurred.',
    };
  }

  removeEmptyParams(params: object): object {
    const newParams = {};
    Object.entries(params).map(([key, value]) => {
      if (value) {
        newParams[key] = value;
      }
      if (value === 'time') {
        delete newParams[key];
      }
    });
    return newParams;
  }
}
